import { render, staticRenderFns } from "./LibraryFolder.vue?vue&type=template&id=188804ed&scoped=true"
import script from "./LibraryFolder.vue?vue&type=script&lang=js"
export * from "./LibraryFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188804ed",
  null
  
)

export default component.exports